import { Splide } from '@splidejs/splide';


const footerSlider = (slidesCount) => ({
    init(){
        this.initSlider()
    },
    initSlider() {
        new Splide( '.footer-slider', {
            drag   : 'free',
            focus  : 'center',
            perPage: slidesCount,
            pauseOnHover: false,
            mediaQuery: "min",
            autoWidth: true,
            arrows: false,
            pagination: false,
            gap: 40,
            breakpoints: {
                990: {
                    destroy: true
                },
            }
        } ).mount();
    }
})



export default footerSlider

document.addEventListener("alpine:init", () => {
    Alpine.data("footer_slider", footerSlider);
})
